import { Box, IconButton, Menu, Divider } from "@mui/material"
import { MoreVert } from "@mui/icons-material"
import { useState } from "react"
import InvoicePaidMenuItem from "../../actionButtons/InvoicePaidMenuItem"
import InvoiceMarkAsPendingMenuItem from "../../actionButtons/InvoiceMarkAsPendingMenuItem"
import InvoiceMarkAsPastDueMenuItem from "../../actionButtons/InvoiceMarkAsPastDueMenuItem"
import CreateInvoiceReminderMenuItem from "../../actionButtons/CreateInvoiceReminderMenuItem"

const InvoiceStateMenu = () => {

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
		<Box display={"inline"}>
			<IconButton
        onClick={handleClick}
      >
				<MoreVert />
			</IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <InvoicePaidMenuItem handleClose={handleClose} />
        <InvoiceMarkAsPendingMenuItem handleClose={handleClose} />
        <InvoiceMarkAsPastDueMenuItem handleClose={handleClose} />
        <Divider />
        <CreateInvoiceReminderMenuItem handleClose={handleClose} />
      </Menu>
		</Box>
  )
}

export default InvoiceStateMenu
